import defaultImg from '../../../../assests/mobileImg.png';
import classes from './MobileBanner.module.css';

const MobileBanner = ({ text, image = defaultImg, color = '#FEE', className }) => {

    return (
        <div
            className={`${classes.MobileBanner} ${className || ''}`}
            style={{ backgroundColor: color }}
        >
            <p className={classes.Text}>{text}</p>
            <img className={classes.Image} src={image} alt="" />
        </div>
    );
};

export default MobileBanner;
